module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-fixed",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "status-bar",
    attrs: {
      "id": "status"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.isback) ? _c('div', {
    staticClass: "left-btn",
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-houtui gray6 f36"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-txt"
  }, [_vm._v(_vm._s(_vm.title || '悦小妖'))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRight),
      expression: "showRight"
    }],
    staticClass: "right-btn",
    attrs: {
      "id": "right_btn"
    }
  }, [_vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "editok right"
  }, [_c('i', {
    staticClass: "f26 ionicons ion-share share"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f24fb9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top_fixed.vue
// module id = 1977
// module chunks = 215